<template>
  <div>
    <form @submit.prevent="register">
      <h2>Register</h2>
      <div>
        <label>Username: <input required v-model="username"/></label>
      </div>
      <div>
        <label
          >Password: <input required type="password" v-model="password" />
        </label>
      </div>
      <button>Register</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "Register",
  data: () => ({ username: "", password: "" }),
  methods: {
    async register() {
      await this.axios.post("/auth/register", {
        username: this.username,
        password: this.password
      });
    }
  }
};
</script>

<style scoped></style>
